import { defineStore } from 'pinia'

import state from './state.js'
import getters from './getters.js'
import actions from './actions.js'

const useRolesStore = defineStore('roles', {
  state,
  getters,
  actions
})

export default useRolesStore
